import styled from 'styled-components';

export const InterlinkingContainer = styled.div`
    background-color: #fff;
    padding: 0 2rem 2rem;
    border-radius: 12px;
    margin-bottom: 4rem;
`;

export const InterlinkingItem = styled.div`
`;

export const InterlinkingHeader = styled.h2`
    margin-top: 2rem;
    font-size: 2rem;
    color: rgb(20,24,35);
    font-family: 'Rubik';
    font-weight: 600;
`;

export const InterlinkingBody = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 2rem;
`;

export const InterlinkingAnchor = styled.a`
    flex-basis: 20%;
    padding-bottom: 8px;
    &:after {
        content: " ";
    }
`;

export const OneWayInterlinkingTopContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const OneWayInterlinkingContainer = styled.div`
    background-color: #fff;
    padding: 0 2rem 2rem;
    border-radius: 12px;
    margin-bottom: 4rem;
    width: 350px
`;

export const OneWayInterlinkingBody = styled.div`
    display: flex;
    margin-top: 2rem;
    flex-direction: column;
`;

export const OneWayInterlinkingAnchor = styled.a`
    padding-bottom: 8px;
    &:after {
        content: " ";
    }
`;

export const HeaderInterlinkingAnchor = styled.a`
    padding-bottom: 8px;
    color: black;
    &:after {
        content: " ";
    }
`;